import React from 'react';
import { Button as RBButton } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Button({ children, to, variant = 'primary', type = 'button', style, ...rest }) {
  const dangerStyles = variant === 'danger' ? {
    backgroundColor: 'var(--color-accent)',
    borderColor: 'var(--color-accent)',
    ...style
  } : style;

  if (to) {
    return (
      <RBButton as={Link} to={to} variant={variant} className="rounded-3" style={dangerStyles} {...rest}>
        {children}
      </RBButton>
    );
  }

  return (
    <RBButton variant={variant} type={type} className="rounded-3" style={dangerStyles} {...rest}>
      {children}
    </RBButton>
  );
}

export default Button;
